import {
  CURRENT_SIZE_RULE,
  LEGACY_SIZE_RULE,
  sizeRuleFromRecorded,
  type SizeRule,
} from '@features/quotations/utils/pricing';
import { SalesOrderStatus } from '../types/salesOrder.types';

/**
 * 14ykpqtr22u — the size rule an SO's Weight Breakdown uses. A submitted SO keeps the rule it was
 * posted under (recorded on its submission snapshot as `smallDiametersMm`; SOs posted before the
 * field existed used the legacy rule, where 16mm was small). Anything not yet submitted — drafts,
 * and SOs whose post is still in flight (read-only, but no snapshot yet) — uses the current rule.
 * Keyed on status, never on read-only. Pure: call it as a plain value, not a hook.
 */
export function resolveSalesOrderSizeRule(
  status: SalesOrderStatus,
  submittedSnapshotJson: string | null | undefined,
): SizeRule {
  if (status !== SalesOrderStatus.Submitted) return CURRENT_SIZE_RULE;
  if (!submittedSnapshotJson) return LEGACY_SIZE_RULE;
  try {
    const parsed: unknown = JSON.parse(submittedSnapshotJson);
    const recorded =
      parsed != null && typeof parsed === 'object'
        ? (parsed as { smallDiametersMm?: unknown }).smallDiametersMm
        : undefined;
    return sizeRuleFromRecorded(recorded);
  } catch {
    return LEGACY_SIZE_RULE;
  }
}
